import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  Loading,
  InputCustom,
  InputCurrency,
  HttpError,
  SelectCustom,
  TextArea
} from "../../components"
import InputDinheiroBR from "../../components/InputDinheiroBR"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModalWithLabel } from "../modais"
class ItensDeContratoForm extends Component {
  constructor() {
    super()
    this.mapItem = this.mapItem.bind(this)
    this.getItens = this.getItens.bind(this)
    this.onChangeDescricao = this.onChangeDescricao.bind(this)
    this.onChangeValorUnitario = this.onChangeValorUnitario.bind(this)
    this.onChangeQuantidade = this.onChangeQuantidade.bind(this)
    this.onChangeUnidade = this.onChangeUnidade.bind(this)
    this.calculateValorItem = this.calculateValorItem.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      showForm: false,
      unidades: [],
      valorUnitario: "",
      valor: "",
      currentDescricao: "",
      descricao: "",
      quantidade: "",
      unidadeDeMedida: "",
      contrato: ""
    }
  }
  componentWillMount() {
    this.getItens()
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  sendForm(event) {
    event.preventDefault()
    var tipoAditivo = this.props.editingItem.realinhamento
      ? "realinhamento"
      : this.props.editingItem.aditivo
        ? "realinhamento"
        : undefined
    var params = {
      valor_unitario: this.state.valorUnitario,
      quantidade: this.state.quantidade,
      valor: this.state.valor,
      descricao: this.state.descricao,
      unidade_de_medida_id: this.state.unidadeDeMedida,
      aditivo: tipoAditivo
    }
    this.toggleLoadModal()
    ApiHelper.updateItemDeContratoWith(
      this.props.editingItem.id,
      params,
      error => {
        this.toggleLoadModal()
        if (error) {
        } else {
          this.props.callBackItens()
        }
      }
    )
  }
  getItens() {
    ApiHelper.getItensEdit(this.props.editingItem.id, (data, error) => {
      if (data) {
        this.mapItem(data.item)
        this.setState(
          {
            unidades: data.unidades,
            showForm: true
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  mapItem(item) {
    var currentFields = {
      valorUnitario: parseFloat(item.valor_unitario),
      valor: item.valor,
      descricao: item.descricao,
      quantidade: item.quantidade,
      unidadeDeMedida: item.unidade_de_medida_id,
      contrato: item.contrato_num_contrato
    }
    this.setState(currentFields)
  }
  calculateValorItem() {
    var quantidade = this.state.quantidade
    var valorUnitario = this.state.valorUnitario
    if (quantidade && valorUnitario) {
      var valor = quantidade * valorUnitario
      this.setState({
        valor: valor
      })
    } else {
      this.setState({
        valor: 0.0
      })
    }
  }
  onChangeDescricao(event) {
    var newValue = event.target.value
    this.setState({
      descricao: newValue
    })
  }
  onChangeUnidade(event) {
    var newValue = event.target.value
    this.setState({
      unidadeDeMedida: newValue
    })
  }
  onChangeQuantidade(event) {
    var newValue = event.target.value
    this.setState(
      {
        quantidade: newValue
      },
      () => {
        this.calculateValorItem()
      }
    )
  }
  onChangeValorUnitario(event, value) {
    var newValue = value
    this.setState(
      {
        valorUnitario: newValue
      },
      () => {
        this.calculateValorItem()
      }
    )
  }
  render() {
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    if (!this.state.showForm) {
      return <Loading />
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div>
          <div className="card card-plain">
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">Editar item de contrato</h4>
              <p className="category">{this.state.currentDescricao}</p>
            </div>
            <div className="card-content">
              <form>
                <div className="row">
                  <TextArea
                    onChange={this.onChangeDescricao}
                    rows="2"
                    sizeClass="col-md-10"
                    label={"Descrição do item"}
                    value={this.state.descricao}
                  />
                </div>
                <div className="row">
                  {!this.props.editingItem.aditivo && (
                    <InputDinheiroBR
                      onChange={this.onChangeValorUnitario}
                      sizeClass="col-md-2"
                      label={"Valor Unitário"}
                      defaultValue={this.state.valorUnitario}
                    />
                  )}
                  {!this.props.editingItem.realinhamento && (
                    <InputCustom
                      step="any"
                      onChange={this.onChangeQuantidade}
                      type="number"
                      sizeClass="col-md-2"
                      label="Quantidade"
                      value={this.state.quantidade}
                    />
                  )}
                  {!this.props.editingItem.realinhamento &&
                    !this.props.editingItem.aditivo && (
                      <div>
                        <SelectCustom
                          onChange={this.onChangeUnidade}
                          sizeClass="col-md-1"
                          options={this.state.unidades}
                          label={"Unidade de medida"}
                          value={this.state.unidadeDeMedida}
                        />
                        <InputCustom
                          sizeClass="col-md-5"
                          label={"Valor total do item"}
                          value={Util.formatCurrency(this.state.valor)}
                          disabled={true}
                        />
                      </div>
                    )}
                </div>
                <div className="row">
                  <button
                    onClick={this.sendForm}
                    type="submit"
                    className="btn btn-primary pull-left"
                    data-background-color="as-blue"
                  >
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(ItensDeContratoForm)



// WEBPACK FOOTER //
// ./src/views/modais/ItensDeContratoForm.js